import React, { Component } from "react";

import colors from "../../colors";
// import menu from "../data/data";//menu
import Slider from "./Slider";

import ReactHtmlParser from "react-html-parser";
const home =
  "<ul> <li>To establish National level hydrological modeling framework for in season hydrological fluxes estimation at daily/weekly/fortnightly time step&nbsp;</li> </ul> <ul> <li>To establish a comprehensive field experimentation setup for calibration and validation of model computed flux outputs (Soil Moisture, ET)&nbsp;</li> </ul> <ul> <li>To Develop of web-enabled in-season hydrological fluxes information for the entire country on India-WRIS/Bhuvan</li> </ul>";

export default class VICProjObjective extends Component {
  render() {
    return (
      <div
      className="cardeck_full"
     
    >
      <div className="carddeck_inner"
        style={{
        
          backgroundColor: colors.background,
        }}
      >
          <Slider />

          <main style={{ flexGrow: "1", overflowX: "auto" }}>
            <div
              className="card"
              style={{ padding: "15px", width: "100%", height: "100%" }}
            >
              {/* <main style={{flexGrow: "1", width:"100%", height:"100%", flexGrow:1, flexBasis:"content", alignSelf:"bsaeline"}}>
      <div className="card"> */}
              <div className="card-body">
                <h3 className="card-title" style={{ color: "#002171" }}>
                  Operational Web-based National Hydrological Modelling System
                </h3>
                <hr />
                {ReactHtmlParser(home)}
              </div>
            </div>
          </main>
        </div>
      </div>
    );
  }
}
